// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-d-1-eec-1-de-ae-05-4-aae-90-bd-a-3-a-14-c-72-bd-8-c-chat-tsx": () => import("./../../../src/pages/d1eec1de-ae05-4aae-90bd-a3a14c72bd8c/chat.tsx" /* webpackChunkName: "component---src-pages-d-1-eec-1-de-ae-05-4-aae-90-bd-a-3-a-14-c-72-bd-8-c-chat-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-blog-article-page-tsx": () => import("./../../../src/templates/BlogArticlePage.tsx" /* webpackChunkName: "component---src-templates-blog-article-page-tsx" */)
}

